import { gsap } from 'gsap';

export const aboutUsAnimation = () => {
	const maskSvg = document.querySelector('.mask-svg');
	if (!maskSvg) return;

	const rotatingMask = document.querySelector('#rotating-mask g');
	if (!rotatingMask) return;

	gsap.set(maskSvg, { y: 100 });

	gsap.set(rotatingMask, {
		opacity: 1,
		scale: 0.4,
		y: 0,
		transformOrigin: '50% 50%',
	});

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: maskSvg,
			start: 'top 40%',
			end: '+=1500',
			scrub: true,
		},
	});

	tl.to(rotatingMask, {
		rotate: 20,
		scale: 1.2,
		duration: 1.2,
		ease: 'none',
	})
		.to(rotatingMask, {
			scale: 5,
			duration: 1.2,
			ease: 'none',
		})
		.to(maskSvg, { y: 0, duration: 1.2, ease: 'naturalEasing' }, 0);

	if (
		navigator.userAgent.indexOf('Safari') !== -1 &&
		navigator.userAgent.indexOf('Chrome') === -1
	) {
		gsap.fromTo(
			maskSvg,
			{ height: 'auto' },
			{ height: '100%', duration: 1.2, ease: 'naturalEasing' }
		);
	}
};
